<!-- 缴费记录 -->
<template>
  <div>
    <!-- <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户姓名">
              <j-input placeholder="请输入用户姓名模糊查询" v-model="queryParam.userName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户手机号">
              <a-input placeholder="请输入用户手机号" v-model="queryParam.userPhone"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              </span>
          </a-col>
        </a-row>
      </a-form>
    </div> -->
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">
        <template slot="userNowAccountNum" slot-scope="text, record">
          <a-tag style="font-size: 14px" :color="record.userNowAccountNum==null?'':record.userNowAccountNum<=0?'red':'green'">{{record.userNowAccountNum}}</a-tag>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
  import JInput from '@/components/jeecg/JInput'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import {isUndefined,isNull,isUndefinedAndNull} from'@/utils/validate'
  import {payWayObj,payTypeObj,meterTypeObj,accountChangeObj} from '@/utils/constants/commonConstant'

  export default {
    name: 'DeductionRecord',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      JInput
    },
    props:{
      id:{
        type: String,
        default: ''
      }
    },
    data () {
      return {
        url: {
          list: "/jeecg-charge/meter/meterUserPayRecord/list",
        },
        queryParam: {},
        accountChangeDate: [],
      }
    },
    watch:{
      id(val){
        if(val){
          this.loadData();
        }
      }
    },
    created() {},
    mounted(){},
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'meterUserId',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('用户地址'),
            align:"center",
            dataIndex:'userAddr',
            width:200,
            ellipsis: true,
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },
          {
            title: this.$t('购买金额(元)'),
            align:"center",
            dataIndex: 'userPayAccountNum',
            width:150,
            customRender: (t,r,index) => {
              if(!isUndefined(r.userAccountPayType)&&[2,4,6].includes(r.userAccountPayType)) {
                return '-'+t
              }
              return t
            }
          },
          {
            title: this.$t('购买量(吨)'),
            align:"center",
            dataIndex: 'payWaterNum',
            width:150,
            customRender: (t,r,index) => {
              if(isUndefinedAndNull(t)) {
                return '--'
              }
              if(!isUndefinedAndNull(r.userAccountPayType)&&[2,4,6].includes(r.userAccountPayType)) {
                return '-'+t
              }
              return t
            }
          },
          {
            title: this.$t('操作类型'),
            align:"center",
            dataIndex: 'userAccountPayType',
            width:100,
            customRender: (t,r,index) => {
              let data = payTypeObj
              if(!isUndefined(data[t])) {
                return this.$t(data[t])
              }
              return this.$t('未知')
            }
          },
          {
            title: this.$t('缴费途径'),
            align:"center",
            dataIndex: 'payWay',
            width:100,
            customRender: (t,r,index) => {
              let obj = payWayObj
              if(!isUndefined(obj[t])) {
                return this.$t(obj[t])
              }
              return this.$t('未知')
            }
          },
          {
            title: this.$t('交易流水号'),
            align:"center",
            dataIndex: 'payOrderId',
            width:200,
            ellipsis: true
          },
          {
            title: this.$t('剩余金额(元)'),
            align:"center",
            dataIndex: 'userNowAccountNum',
            scopedSlots: { customRender: 'userNowAccountNum' },
            width:150,
          },
          {
            title: this.$t('缴费时间'),
            align:"center",
            dataIndex: 'createTime',
            width:150,
            customRender: (t,r,index) => {
              // 撤销充值的记录只是修改记录的更新时间等信息，不增加记录，所以需要这样处理现实操作时间
              if(!isNull(r.paymentTime)&&r.paymentTime!="") {
                return r.paymentTime
              }
              return t
            }
          },
          {
            title: this.$t('操作员'),
            align:"center",
            dataIndex: 'createBy',
            width:150,
            customRender: (t,r,index) => {
              // 撤销充值的记录只是修改记录的更新时间等信息，不增加记录，所以需要这样处理现实操作时间
              if(!isNull(r.updateBy)&&r.updateBy!="") {
                return r.updateBy
              }
              return t
            }
          },
        ]
      }
    },
    methods: {
      loadData(){
        var params = this.getQueryParams();//查询条件
        params.meterUserId = this.id;
        getAction(this.url.list,params).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      onDateRangeChangeAccountChange(value, dateStrings) {
        if(dateStrings[0]!=''&&dateStrings[1]!='') {
          this.queryParam.beginDate = dateStrings[0];
          this.queryParam.endDate = dateStrings[1];
        }else{
          if(this.queryParam['beginDate']) {
            delete this.queryParam['beginDate']
          }
          if(this.queryParam['endDate']) {
            delete this.queryParam['endDate']
          }
        }
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>